import axios from "axios";
import * as actionTypes from "./ActionTypes";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

// User register
export const userRegister = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.REGISTER_USER_INIT });

  try {

    const res = await axios.post(`${BASE_URL}/signup`, payload);

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.REGISTER_USER_FAIL,
        payload: "error",
      });
    } else {
      // set the register Token
      localStorage.setItem('regToken', res.data.data.token);
      dispatch({
        type: actionTypes.REGISTER_USER_SUCCESS,
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    console.error("Register error: ", error);
    dispatch({
      type: actionTypes.LOGIN_FAIL,
      payload: "error",
    });
    throw error;
  }
};

// User Profile Details (Create and Update)
export const userProfileDetails = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.USER_PROFILE_DETAILS_INIT });

  try {
    // get register token
    const regToken = localStorage.getItem('regToken');
    let res = "";

    const authToken = localStorage.getItem('authToken');

    if (regToken || authToken) {
      res = await axios.post(`${BASE_URL}/save-profile`, payload, {
        headers: {
          Authorization: `Bearer ${regToken || authToken}`
        }
      });
    }

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.USER_PROFILE_DETAILS_FAIL,
        payload: "error",
      });
    } else {
      dispatch({
        type: actionTypes.USER_PROFILE_DETAILS_SUCCESS,
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    console.error("Register error: ", error);
    dispatch({
      type: actionTypes.USER_PROFILE_DETAILS_FAIL,
      payload: "error",
    });
    throw error;
  }
};

// User uplaod images (Create and Update)
export const userImagesUpload = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.USER_IMAGES_UPLOAD_INIT });

  try {
    // get register token
    const regToken = localStorage.getItem('regToken');
    let res = "";

    const authToken = localStorage.getItem('authToken');

    if (regToken || authToken) {
      res = await axios.post(`${BASE_URL}/save-profile`, payload, {
        headers: {
          Authorization: `Bearer ${regToken || authToken}`,
          'Content-Type': 'multipart/form-data',
        },
      });
    }

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.USER_IMAGES_UPLOAD_FAIL,
        payload: "error",
      });
    } else {
      dispatch({
        type: actionTypes.USER_IMAGES_UPLOAD_SUCCESS,
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    console.error("Register error: ", error);
    dispatch({
      type: actionTypes.USER_IMAGES_UPLOAD_FAIL,
      payload: "error",
    });
    throw error;
  }
};

// User login
export const userlogin = (email, password) => async (dispatch) => {

  dispatch({ type: actionTypes.LOGIN_INIT });

  try {

    const res = await axios.post(`${BASE_URL}/login`, { email, password });

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.LOGIN_FAIL,
        payload: "error",
      });
      toast.error('Invalid Email or Password');
    } else {
      // set auth token
      localStorage.setItem("authToken", res?.data?.data?.token);
      localStorage.setItem("id", res?.data?.data?.user?.id);
      localStorage.removeItem("regToken");
      dispatch({
        type: actionTypes.LOGIN_SUCCESS,
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    dispatch({
      type: actionTypes.LOGIN_FAIL,
      payload: "error",
    });
    throw error;
  }
};

//Forgot Password
export const forgotPassword = (email) => async (dispatch) => {

  dispatch({ type: actionTypes.LOGIN_INIT });

  try {

    const res = await axios.post(`${BASE_URL}/forgot-password`, { email });

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.LOGIN_FAIL,
        payload: "error",
      });
    } else {
      dispatch({
        type: actionTypes.LOGIN_SUCCESS,
        payload: { res: res.data, email },
      });
    }

    return res;

  } catch (error) {
    dispatch({
      type: actionTypes.LOGIN_FAIL,
      payload: "error",
    });
    throw error;
  }
};


//Reset Password
export const resetPassword = (token, email, password, password_confirmation) => async (dispatch) => {

  dispatch({ type: actionTypes.USER_RESET_PASSWORD_INIT });

  try {

    const res = await axios.post(`${BASE_URL}/reset-password`, { token, email, password, password_confirmation });

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.USER_RESET_PASSWORD_FAIL,
        payload: "error",
      });
    } else {
      dispatch({
        type: actionTypes.USER_RESET_PASSWORD_SUCCESS,
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    dispatch({
      type: actionTypes.USER_RESET_PASSWORD_FAIL,
      payload: "error",
    });
    throw error;
  }
};

//change Password
export const changePassword = ({
  old_password,
  new_password,
  confirm_new_password
}) => async (dispatch) => {

  dispatch({ type: actionTypes.CHANGE_PASSWORD_INIT });

  try {
    const authToken = localStorage.getItem('authToken');
    let res = "";

    if (authToken) {
      res = await axios.post(`${BASE_URL}/change-password`, { old_password, new_password, confirm_new_password }, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }

    if (res.data.success === false) {
      dispatch({
        type: actionTypes.CHANGE_PASSWORD_FAIL,
        payload: "error",
      });
    } else {
      dispatch({
        type: actionTypes.CHANGE_PASSWORD_SUCCESS,
        payload: res.data,
      });
    }

    return res;

  } catch (error) {
    dispatch({
      type: actionTypes.CHANGE_PASSWORD_FAIL,
      payload: "error",
    });
    throw error;
  }
};

// User Logout
export const userLogout = (navigate) => async (dispatch) => {
  dispatch({ type: actionTypes.LOGOUT_INIT });

  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      toast.error("No authentication token found! Please log in again.");
      dispatch({ type: actionTypes.LOGOUT_FAIL });
      return;
    }

    const res = await axios.post(
      `${BASE_URL}/logout`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      dispatch({ type: actionTypes.LOGOUT_SUCCESS });
      localStorage.removeItem("authToken");
      localStorage.removeItem("id");
      localStorage.clear();

      // toast.success("Logout successful");
      window.location.replace(`/`);  
      // navigate("/");
    } else {
      throw new Error(res.data.message || "Logout failed");
    }
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      toast.error("Session expired. Please log in again.");
      navigate("/login");
    } else {
      toast.error(error.response?.data?.message || "Logout error");
    }

    dispatch({ type: actionTypes.LOGOUT_FAIL });
  }
};